export default "__VITE_ASSET__e67fb3fc__"